module.exports = __webpack_public_path__ + "img/student.17157e6b.svg";